import { jwtDecode } from 'jwt-decode'

export const decodeToken = <T = unknown>(token: string) => jwtDecode<T>(token)
